import { AvailableCountries } from '@invitae/location-lite-react';

var DEFAULT_COUNTRY = 'US';
var AVAILABLE_COUNTRIES = AvailableCountries;
var countryCodeToLocale = {
    CA: 'en-CA',
    US: 'en-US',
};
var toOpenGraphLocale = function (countryCode) {
    if (countryCode === void 0) { countryCode = DEFAULT_COUNTRY; }
    var currentLocale = (countryCodeToLocale === null || countryCodeToLocale === void 0 ? void 0 : countryCodeToLocale[countryCode]) || countryCodeToLocale[DEFAULT_COUNTRY];
    return currentLocale.replace(/-/g, '_');
};
/**
 * list of prefixes that should not have country code in their url
 */
var pathsWithoutCountryCode = [
    'hcp',
    'hcx-order',
    'pio',
    'request-a-kit',
    'start-order',
];

export { AVAILABLE_COUNTRIES, DEFAULT_COUNTRY, countryCodeToLocale, pathsWithoutCountryCode, toOpenGraphLocale };
//# sourceMappingURL=setup.esm.js.map
